import { ReactElement } from 'react';

import { BindingCreator } from '@dreryk/react-common';
import { Multiselect } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';

import { AppointmentConfirmationStatus } from './AppointmentConfirmationStatusField.types';
import {
   useAppointmentConfirmationStatusFilterSearchParamHandler,
   useAppointmentConfirmationStatusTriggerLabelExtractor,
} from './AppointmentConfirmationStatusField.hooks';
import { StyledAppointmentConfirmationStatusField } from './AppointmentConfirmationStatusField.styled';
import { APPOINTMENT_CONFIRMATION_STATUS_ID_MAP } from './AppointmentConfirmationStatusField.utils';

type AppointmentFilterAppointmentConfirmationStatusFieldFormBeanPart = {
   appointmentConfirmationStatuses: AppointmentConfirmationStatus[];
};

type AppointmentConfirmationStatusFieldProps = {
   register: BindingCreator<
      AppointmentFilterAppointmentConfirmationStatusFieldFormBeanPart,
      'appointmentConfirmationStatuses'
   >;
   currentFilter: AppointmentConfirmationStatus[];
};

const items = Object.keys(APPOINTMENT_CONFIRMATION_STATUS_ID_MAP) as AppointmentConfirmationStatus[];

export const AppointmentConfirmationStatusField = (props: AppointmentConfirmationStatusFieldProps): ReactElement => {
   const handleHide = useAppointmentConfirmationStatusFilterSearchParamHandler(props.currentFilter);

   return (
      <StyledAppointmentConfirmationStatusField>
         <Multiselect<AppointmentConfirmationStatus>
            testId={'appointmentConfirmationStatuses'}
            triggerLabelExtractor={useAppointmentConfirmationStatusTriggerLabelExtractor()}
            placeholder={appointmentsTranslationKeys.appointmentConfirmationStatusFilter.selectConfirmationStatuses}
            controller={props.register('appointmentConfirmationStatuses')}
            onHide={handleHide}
         >
            <>
               <Multiselect.SelectAll<AppointmentConfirmationStatus>
                  testId={'selectAllConfirmationStatuses'}
                  items={items}
                  selectAllLabel={appointmentsTranslationKeys.appointmentConfirmationStatusFilter.selectAll}
               />
               <Multiselect.List items={items}>
                  {(item) => (
                     <Multiselect.Item
                        item={item}
                        testId={item}
                        label={appointmentsTranslationKeys.appointmentConfirmationStatusMap[item]}
                     />
                  )}
               </Multiselect.List>
            </>
         </Multiselect>
      </StyledAppointmentConfirmationStatusField>
   );
};
